export async function resizeImage(file, max = 1600, quality = 0.85) {
  const url = URL.createObjectURL(file);
  try {
    const im = await new Promise((res, rej) => {
      const i = new Image();
      i.onload = () => res(i);
      i.onerror = rej;
      i.src = url;
    });
    const scale = Math.min(1, max / Math.max(im.naturalWidth, im.naturalHeight));
    const canvas = document.createElement("canvas");
    canvas.width = Math.round(im.naturalWidth * scale);
    canvas.height = Math.round(im.naturalHeight * scale);
    canvas.getContext("2d").drawImage(im, 0, 0, canvas.width, canvas.height);
    const blob = await new Promise((res) => canvas.toBlob(res, "image/jpeg", quality));
    return new File([blob], file.name.replace(/\.\w+$/, "") + ".jpg", { type: "image/jpeg" });
  } finally {
    URL.revokeObjectURL(url);
  }
}

export const formatRange = (start, end, lang) => {
  const loc = lang === "es" ? "es-NI" : "en-US";
  const s = new Date(`${start}T12:00`), e = new Date(`${end}T12:00`);
  const md = { month: "short", day: "numeric" };
  if (start === end) return s.toLocaleDateString(loc, { ...md, year: "numeric" });
  const sameYear = s.getFullYear() === e.getFullYear();
  return `${s.toLocaleDateString(loc, sameYear ? md : { ...md, year: "numeric" })} – ${e.toLocaleDateString(loc, { ...md, year: "numeric" })}`;
};
